module.exports = "<app-subheader></app-subheader>\n<router-outlet></router-outlet>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/portfolio/portfolio.component.html
// module id = ../../../../../src/app/portfolio/portfolio.component.html
// module chunks = 0